import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import star from "../assets/images/star.gif";
import useActivityLogger from "../utils/useActivityLogger";

function GetCardInstructions() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  // ✅ OBO detection
  const isOBO = !!sessionStorage.getItem("OnBehalfUserId");
  
  // Check if user came from Card button (no back button) or from Instant Access (show back button)
  const fromCardButton = location?.state?.fromCardButton === true;
  
  const { logClick } = useActivityLogger({
    moduleCode: "DPY",
  });

  // ✅ Handle Back button click
  const handleBackClick = (e) => {
    e.preventDefault();
    logClick(
      `${isOBO ? "OBO.Button.Back" : "DPY.Button.Back"}`,
      `${isOBO ? "OBO-" : ""}Clicked Back from Get Card Instructions`
    );
    navigate("/doughsummary"); // Navigate back to Instant Access page
  };

  return (
    <div className="dashboard-container">
      {/* ✅ Back button only shown when coming from Instant Access (not from Card button) */}
      {!fromCardButton && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', marginBottom: '15px', paddingLeft: '0' }}>
          <a href="#" className="back-link" onClick={handleBackClick}>
            <span className="back-arrow-icon"></span>
            <span>{t("backbutton")}</span>
          </a>
        </div>
      )}

      <h1 className="card-load-success-title">{t("Get a Card")}</h1>
      <div className="congrats-image-container">
        <img src={star} alt="" style={{ width: '148px', height: '148px' }} />
      </div>
      <div className="card-load-success-info">
        <p className="get-card-main-text">
          Your in-store kiosk may allow you to obtain and register a prepaid Mastercard®.<br />
          Once your card is registered, Mastercard is accepted everywhere, and you can load funds to it from anywhere.
        </p>
        <p className="get-card-secondary-text">
          Please ask your manager for additional details.
        </p>
      </div>
    </div>
  );
}

export default GetCardInstructions;